import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";

import { SIGN_WIDGET_URL_KEY } from "@mk/med-sign";
import { FormsModule } from "@angular/forms";
import { AuthModule } from "@app/oauth/auth.module";
import { InitializerService } from "@app/services/initializer.service";
import { env } from "@environments/environment";
import { AuthWithForcedLoginGuard } from "./oauth/auth-with-forced-login.guard";
import { AuthInterceptor } from "./oauth/auth-interceptor";
import { ErrorInterceptor } from "./oauth/error-interceptor";
import {
  MedIconBookModule,
  MedIconCarModule,
  MedIconCloseModule,
  MedIconDragIndicatorModule,
  MedIconFilterModule,
  MedIconHistoryModule,
  MedIconHospitalBuildingModule, MedIconMinusCircleModule,
  MedIconNotificationModule,
  MedIconRefreshModule,
  MedIconStopwatchModule,
  MedIconTransactionModule,
  MedIconUsersModule,
  MedIconVisibilityModule,
} from "@mk/med-icons";
import { ButtonModule } from "primeng/button";
import { TieredMenuModule } from "primeng/tieredmenu";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MED_POPUP_COMPONENTS_MAP,
  MED_TOOLTIP_COMPONENTS_MAP,
  MedAvatarModule,
  MedBtnModule, MedBubbleModule, MedGroupControlModule, MedLinkModule,
  MedModalModule,
  MedNotificationContainerModule, MedPopupContentModule, MedSidebarModule,
  MedTooltipContentModule,
} from "@mk/med-ui";
import { registerLocaleData } from "@angular/common";
import localeUK from "@angular/common/locales/uk";
import { MedNotificationModule } from "@mk/med-notification";
import { BadgeModule } from "primeng/badge";
import { LogisticComponentsModule } from "@app/components/logistic-components.module";
import { HeaderComponent } from "@app/components/header/header.component";
import { SidebarComponent } from "@app/components/sidebar/sidebar.component";
import { BreadcrumbsModule } from "@app/components/breadcrumbs/breadcrumbs.module";
import { ErrorModule } from "@app/components/error/error.module";
import { AppComponent } from "@app/components/app-component/app.component";
import { SignDemoModule } from "@app/components/sign-demo/sign-demo.module";
import { StateSwitchComponent } from "@app/components/state-switch/state-switch.component";
import { SidebarModule } from "primeng/sidebar";
import {
  ViewDistributionModalComponent,
} from "@app/components/distribution/view/view-distribution-modal/view-distribution-modal.component";
import { DropdownModule } from "primeng/dropdown";
import { SearchModule } from "@app/components/search/search.module";
import {OverlayPanelModule} from "primeng/overlaypanel";

registerLocaleData(localeUK);

const medTooltipComponentsMap = new Map();

const medPopupComponentsMap = new Map();

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    StateSwitchComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    SignDemoModule,
    BreadcrumbsModule,
    AuthModule.forRoot(),
    ErrorModule,
    MedIconCarModule,
    LogisticComponentsModule,
    MedIconDragIndicatorModule,
    MedIconHospitalBuildingModule,
    MedIconUsersModule,
    MedBtnModule,
    MedNotificationContainerModule,
    MedIconCloseModule,
    MedIconNotificationModule,
    ButtonModule,
    TieredMenuModule,
    MedAvatarModule,
    MedModalModule,
    MedTooltipContentModule,
    MedPopupContentModule,
    MedNotificationModule,
    MedLinkModule,
    BadgeModule,
    MedIconTransactionModule,
    MedSidebarModule,
    SidebarModule,
    MedIconHistoryModule,
    MedIconFilterModule,
    MedBubbleModule,
    MedGroupControlModule,
    ViewDistributionModalComponent,
    MedIconBookModule,
    MedIconStopwatchModule,
    DropdownModule,
    SearchModule,
    OverlayPanelModule,
    MedIconVisibilityModule,
    MedIconRefreshModule,
    MedIconMinusCircleModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthWithForcedLoginGuard,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [InitializerService],
      useFactory: (service: InitializerService) => () => service.init(),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: MED_TOOLTIP_COMPONENTS_MAP,
      useValue: medTooltipComponentsMap,
    },
    {
      provide: MED_POPUP_COMPONENTS_MAP,
      useValue: medPopupComponentsMap,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: SIGN_WIDGET_URL_KEY,
      useValue: env.signWidgetUrl,
    },
  ],
})
export class AppModule {}
